// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"656":"caaf65c6","822":"523b752f","906":"5202e4c9","972":"ea83ea3e"}[chunkId] + ".chunk.css";
};